import { library } from '@fortawesome/fontawesome-svg-core';
import type { DefineComponent, HTMLAttributes } from 'vue';
import {
  type FontAwesomeIconProps,
  FontAwesomeIcon as OriginalIcon,
} from '@fortawesome/vue-fontawesome';
import * as duotone from './_fontAwesomeDuotone';
import * as light from './_fontAwesomeLight';
import * as regular from './_fontAwesomeRegular';
import * as solid from './_fontAwesomeSolid';
import { getFontAwesomeIconFromMimeType } from './getFontAwesomeIconFromMimeType';

library.add(duotone, light, regular, solid);

export interface ExtendedFontAwesomeIconProps extends FontAwesomeIconProps, HTMLAttributes {}

const FontAwesomeIcon = OriginalIcon as unknown as DefineComponent<ExtendedFontAwesomeIconProps>;

export { FontAwesomeIcon, getFontAwesomeIconFromMimeType, duotone, light, regular, solid };
